import moment from "moment";

import { VACATION_REQUESTS_STRINGS } from "../constants/strings";

import { DottedLine } from "components/v2";
import StatusChip from "./StatusChip";

import type { RequestStatusT } from "../domain/types/requestStatus.types";
import type { TypeDetailUiT } from "../domain/ui/requestDetail.model";

import mapLeaveIcon from "screens/Vacations/components/LeaveTypes/constants/leaveIconMapper";

const formatDate = (date: Date) =>
  date ? moment.utc(date).format("DD/MM/YYYY") : "—";

type RequestBasicInfoPropsT = {
  type: TypeDetailUiT;
  totalDays: number;
  status: RequestStatusT;
  startDate?: Date;
  endDate?: Date;
};

const RequestBasicInfo = ({
  type,
  totalDays,
  status,
  startDate,
  endDate,
}: RequestBasicInfoPropsT) => {
  const RequestTypeIcon = mapLeaveIcon(type?.icon);

  return (
    <div className="flex flex-col bg-info-I005 rounded-lg p-3 gap-3">
      <div className="flex gap-3">
        <div
          role="img"
          aria-label={type?.name ?? "Ícono de tipo de solicitud"}
          className="flex items-center justify-center bg-white rounded-lg p-2"
        >
          {RequestTypeIcon && (
            <RequestTypeIcon
              aria-hidden="true"
              size={28}
              color={type?.color ?? "#000000"}
            />
          )}
        </div>
        <dl className="flex flex-col flex-1">
          <dt className="sr-only">Tipo</dt>
          <dd className="truncate">{type?.name ?? "—"}</dd>
          <dt className="sr-only">Días</dt>
          <dd className="text-secondaryText">
            {VACATION_REQUESTS_STRINGS.DETAIL_DAYS_LABEL} {totalDays}
          </dd>
        </dl>
        <StatusChip status={status} />
      </div>
      <DottedLine
        startLabel={formatDate(startDate)}
        endLabel={formatDate(endDate)}
      />
    </div>
  );
};

export default RequestBasicInfo;
